import { formatPasswordRegex } from './regex';

// this helper function use to check state, get error message
// it working with `vuelidate` see docs: https://vuelidate.js.org/#sub-basic-form
/**
 * this function use to check valid input
 * @param {Object} $v.input vuelidate input
 * @returns {Boolean} can be false or null
 */
export const inputStateValid = (input = {}) => {
	return input.$invalid && input.$error
		? false // return false for show color red
		: null; // return null for none color
};

/**
 * this function use to get error message, higher-order function
 * @param {Object} $v.input vuelidate input
 * @param {Object} vm vue instance
 * @returns {String} can be string or null
 */
export const inputStateError = (input = {}) => (vm) => {
	const error = {
		minLength: input.minLength === false && !!input?.$params?.minLength,
		maxLength: input.maxLength === false && !!input?.$params?.maxLength,
		minValue: input.minValue === false && !!input?.$params?.minValue,
		maxValue: input.maxValue === false && !!input?.$params?.maxValue,
		formatPassword: input.formatPassword === false,
		email: input.$invalid && input.$error && input.email === false,
		url: input.$invalid && input.$error && input.url === false,
		requiredField: input.$invalid && input.$error,
	};

	if (error.minLength) {
		return vm.$t('error.min_length', { number: input.$params.minLength.min });
	} else if (error.maxLength) {
		return vm.$t('error.max_length', { number: input.$params.maxLength.max });
	} else if (error.minValue) {
		return vm.$t('error.min_value', { number: input.$params.minValue.min });
	} else if (error.maxValue) {
		return vm.$t('error.max_value', { number: input.$params.maxValue.max });
	} else if (error.formatPassword) {
		return vm.$t('message.password_format');
	} else if (error.email) {
		return vm.$t('error.email');
	} else if (error.url) {
		return vm.$t('error.url');
	} else if (error.requiredField) {
		return vm.$t('error.required_field');
	}

	return null;
};

/**
 * validate format password
 * @param {String} value password
 * @returns {Boolean}
 */
export const formatPassword = (value) => {
	return value ? formatPasswordRegex.test(value) : true;
};